// extracted by mini-css-extract-plugin
export default {"Icon":"PopoverMenu_Icon__llqKk","Separator":"PopoverMenu_Separator__uAs6h","PopoverMenu":"PopoverMenu_PopoverMenu__H0evM"};